import Logo from './Logo'
import Nav from './nav'

const Header = () => (
	<header>
		<div className="viewport">
			<Logo black/>
			<Nav className="nav"/>
		</div>
	</header>
);

export default Header;
